<template>
	<div class="experience-info">
		<AppList :items="infoItems" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import {useExperiencesStore, useRoomsStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const experiencesStore = useExperiencesStore();
		const userStore = useUserStore();
		const roomsStore = useRoomsStore();
		return {getString: useLanguageStore().getString, experiencesStore, userStore, roomsStore};
	},
	name: "ExperienceInfo" ,
	components: {AppList, ModalHeader},
	props: {
		experienceId: {
			type: String,
			required: true
		}
	},
	computed: {
		experience() {
			return this.experiencesStore.businessExperiences.find(experience => experience.experience_id === this.experienceId);
		},
		infoItems() {
			return [
				{
					title: this.getString('info_dogs'),
					switch: true,
					active: this.experience.info_dogs,
					callback: (v) => { this.experience.info_dogs = v; },
				},
				{
					title: this.getString('info_children'),
					switch: true,
					active: this.experience.info_children,
					callback: (v) => { this.experience.info_children = v; },
				},
				{
					title: this.getString('info_allergens'),
					switch: true,
					active: this.experience.info_allergens,
					callback: (v) => { this.experience.info_allergens = v; },
				},
				{
					title: this.getString('info_special_occasion'),
					switch: true,
					active: this.experience.info_special,
					callback: (v) => { this.experience.info_special = v; },
				},
			];
		},
	}
}
</script>

<style scoped lang="scss">

</style>